var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isShowDefault && (_vm.isNullUndefined(_vm.amount) || _vm.amount === ''))?_c('span',[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.defaultLabel))])]})],2):_c('span',[_vm._v(" "+_vm._s(_vm.currencySymbolInner)+_vm._s(_vm.$utils.commaNum(_vm.amountPowered || 0, _vm.precision))+"‏ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }